import { useMutation, useQueryClient } from '@tanstack/react-query';
import { generateEventOrders, type GenerateEventOrdersPayload } from '@api/events';
import { asyncTasksQueryKeys } from '@api/asyncTasks';
import { actionable422Message } from '@/react/api/client';
import { toast } from '@/hooks/use-toast';

export function useGenerateEventOrders() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: GenerateEventOrdersPayload) => generateEventOrders(payload),
    onSuccess: () => {
      // Surface the new task in the Activity Centre.
      queryClient.invalidateQueries({queryKey: asyncTasksQueryKeys.lists()});
    },
    onError: (error) => {
      const description = actionable422Message(error);
      if (description) toast({description, variant: 'destructive'});
    },
  });
}
